module.exports = __webpack_public_path__ + "img/slindshot.813b2cb5.svg";